export function initFileInputs(container = document) {
  const fields = container.querySelectorAll('.file-field');

  fields.forEach(field => {
    const input = field.querySelector('.file-field__input');
    if (!input) return;

    const dropzone = field.querySelector('.file-field__dropzone');
    const button = field.querySelector('.btn');
    const list = field.querySelector('.file-field__list');
    const live = field.querySelector('.file-field__live') || createLiveRegion(field);

    const multiple = input.hasAttribute('multiple');

    // Ouvre le sélecteur
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        input.click();
      });
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          input.click();
        }
      });
    }

    // Clique sur la zone = ouvre
    if (dropzone) {
      dropzone.addEventListener('click', (e) => {
        if (e.target === dropzone) input.click();
      });
    }

    // Changement via explorateur
    input.addEventListener('change', () => {
      updateFileList(input.files);
    });

    // Drag & drop
    ['dragenter', 'dragover'].forEach(evt =>
      dropzone?.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('file-field__dropzone--dragover');
      })
    );
    ['dragleave', 'dragend', 'drop'].forEach(evt =>
      dropzone?.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (evt !== 'drop') dropzone.classList.remove('file-field__dropzone--dragover');
      })
    );
    dropzone?.addEventListener('drop', (e) => {
      dropzone.classList.remove('file-field__dropzone--dragover');
      const dtFiles = e.dataTransfer?.files;
      if (!dtFiles || dtFiles.length === 0) return;

      const files = multiple ? dtFiles : new DataTransferWithFirst(dtFiles).files;
      mergeIntoInputFiles(files);
      updateFileList(input.files);
    });

    // Helpers
    function updateFileList(files) {
      list.innerHTML = '';
      if (!files || files.length === 0) {
        announce('Aucun fichier sélectionné');
        return;
      }

      Array.from(files).forEach((file, idx) => {
        const badge = document.createElement('span');
        badge.className = 'badge badge-xs badge--information';
        badge.setAttribute('role', 'listitem');
        const size = humanSize(file.size);

        // textContent : le nom de fichier est contrôlé par l'utilisateur
        const label = document.createElement('span');
        label.className = 'badge__label';
        label.textContent = `${file.name} · ${size}`;

        const dismiss = document.createElement('button');
        dismiss.type = 'button';
        dismiss.className = 'badge__dismiss';
        dismiss.dataset.index = String(idx);
        dismiss.setAttribute('aria-label', `Retirer ${file.name}`);
        dismiss.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
        dismiss.addEventListener('click', (e) => {
          e.stopPropagation();
          removeFileAt(Number(e.currentTarget.dataset.index));
        });

        badge.append(label, dismiss);
        list.appendChild(badge);
      });

      announce(`${files.length} fichier${files.length > 1 ? 's' : ''} sélectionné${files.length > 1 ? 's' : ''}`);
    }

    function removeFileAt(index) {
      const dt = new DataTransfer();
      Array.from(input.files).forEach((f, i) => {
        if (i !== index) dt.items.add(f);
      });
      input.files = dt.files;
      updateFileList(input.files);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function mergeIntoInputFiles(filesToAdd) {
      const dt = new DataTransfer();
      if (multiple) {
        Array.from(input.files).forEach(f => dt.items.add(f));
        Array.from(filesToAdd).forEach(f => dt.items.add(f));
      } else {
        dt.items.add(filesToAdd[0]);
      }
      input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function humanSize(bytes) {
      if (bytes < 1024) return `${bytes} B`;
      const k = 1024; const sizes = ['KB', 'MB', 'GB', 'TB'];
      let i = -1; do { bytes /= k; i++; } while (bytes >= k && i < sizes.length - 1);
      return `${bytes.toFixed(bytes >= 10 ? 0 : 1)} ${sizes[i]}`;
    }

    function createLiveRegion(host) {
      const div = document.createElement('div');
      div.className = 'file-field__live';
      div.setAttribute('aria-live', 'polite');
      div.style.position = 'absolute';
      div.style.width = '1px';
      div.style.height = '1px';
      div.style.overflow = 'hidden';
      div.style.clip = 'rect(0 0 0 0)';
      div.style.whiteSpace = 'nowrap';
      host.appendChild(div);
      return div;
    }

    function announce(msg) {
      if (!live) return;
      live.textContent = msg;
    }
  });

  // Utilitaire single-file via DataTransfer
  function DataTransferWithFirst(fileList) {
    const dt = new DataTransfer();
    if (fileList && fileList[0]) dt.items.add(fileList[0]);
    return dt;
  }
}